import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { HorizontalFlex } from 'smartsuite-ui';
import { useLabelContext } from '../../shared/hooks/labelContext';
import { getClientTimeStamp } from '../dashboardUtils';
import { getDateTimeRangeStartAndEnd } from './dateTimeRangeVisualizationUtils';
import smartsuiteLogo from './images/smartsuiteLogo.svg';
import brockLogo from './images/brockLogo.svg';

export default function PrintViewHeader(props) {
    const { dashboardLabels, translationLabels } = useLabelContext();

    function buildFilterText() {
        const filterTexts = _(props.filterValues)
            .pickBy((filterValue) => !_.isEmpty(filterValue.values))
            .map((filterValue, filterKey) => {
                const name = props.filterFormatter(filterKey);
                const predicate = filterValue.predicate.textField;
                const value = filterValue.values
                    .map((x) => x.textField)
                    .join(', ');

                return `${name} ${predicate} ${value}`;
            })
            .value();

        const whereClauseTexts = props.whereClauses
            .filter((whereClause) => !_.isEmpty(whereClause.values))
            .map((whereClause) => {
                const name = whereClause.propertyName.textField;
                const predicate = whereClause.predicate.textField;
                const value = whereClause.values.join(', ');

                return `${name} ${predicate} ${value}`;
            });

        return [...filterTexts, ...whereClauseTexts].join('; ');
    }

    const { start, end } = getDateTimeRangeStartAndEnd(props.timeAndPrecision);

    return (
        <div id="printHeader" className="header">
            <div className="header__logo-wrapper">
                <img
                    className="header__smart-suite-logo"
                    src={smartsuiteLogo}
                    alt="SmartSuite Enterprise Logo"
                />
                <HorizontalFlex cssClassModifiers={['flex-wrap']}>
                    <span className="dashboard-header__title">
                        {props.title}
                    </span>
                    {props.subtitle && (
                        <label className="label dashboard-header__subtitle">
                            {`(${props.subtitle})`}
                        </label>
                    )}
                </HorizontalFlex>
                <img
                    className="header__brock-solutions-logo"
                    src={brockLogo}
                    alt="Brock Solutions Logo"
                />
            </div>
            <div id="headerInfoContainer">
                <div className="header__report-info">
                    <div>
                        <label className="header-label">
                            {translationLabels.startDate}
                        </label>
                        <label className="header-value">{start}</label>
                    </div>
                    <div>
                        <label className="header-label">
                            {translationLabels.endDate}
                        </label>
                        <label className="header-value">{end}</label>
                    </div>
                    <div>
                        <label className="header-label">
                            {dashboardLabels.filters}
                        </label>
                        <label className="header-value">
                            {buildFilterText()}
                        </label>
                    </div>
                    <div>
                        <label className="header-label">
                            {dashboardLabels.generatedOn}
                        </label>
                        <label className="header-value">
                            {getClientTimeStamp()}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}

PrintViewHeader.propTypes = {
    filterFormatter: PropTypes.func.isRequired,
    filterValues: PropTypes.instanceOf(Object).isRequired,
    timeAndPrecision: PropTypes.instanceOf(Object).isRequired,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    whereClauses: PropTypes.instanceOf(Array).isRequired,
};
